import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-brand-dark" data-id="element-125">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,107,26,0.1),transparent_50%)]" data-id="element-126" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-127">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-128">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-129">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl leading-[1.1] mb-6 uppercase" data-id="element-130">
              DEJA DE PAGAR UNA CUOTA QUE NO USAS Y TRANSFORMA TU LIVING EN UN{' '}
              <span className="text-brand-orange" data-id="element-131">
                GIMNASIO DE ALTO RENDIMIENTO
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-zinc-400 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-132">
              Entrena cuando quieras, como quieras y sin gastar un centavo en
              equipos caros. La guía definitiva para hombres y mujeres de 20+
              que quieren resultados reales sin salir de su metro cuadrado.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-133">
              <Button data-id="element-134">¡SÍ, QUIERO EMPEZAR MI ENTRENAMIENTO AHORA!</Button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-135">
            <div className="relative w-full max-w-md" data-id="element-136">
              <div className="absolute inset-0 bg-brand-orange blur-[100px] opacity-20 rounded-full" data-id="element-137" />
              <img src="https://cdn.magicpatterns.com/uploads/b2b82axgfL6Aj9NqHmhspg/El_manual_del_gym.png" alt="El Manual del Gym en el Living" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-138" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}